import NextImage from 'next/image'
import { Nameplate } from '@mc/design-system'
import { useStaticData } from '@mc/static-data-react'
import { PrunedCourse } from 'libs/server/api'
import classes from './Hero.module.scss'

export const DefaultNameplate = () => {
  const { course } = useStaticData<{
    course: PrunedCourse
  }>()

  if (!course.leftAlignedNameplate) return null

  return (
    <>
      {/* Desktop */}
      <div className='d-none d-lg-block'>
        <Nameplate
          size='medium'
          image={
            <h1 className='mc-w-100 d-flex align-items-start justify-content-start mc-my-4'>
              <NextImage
                alt={course.instructorName || ''}
                className={classes.nameplateImage}
                src={course.leftAlignedNameplate || ''}
                objectFit='contain'
                sizes='220px'
                layout='fill'
                priority
              />
            </h1>
          }
          subText={course.headline}
          className={classes.nameplate}
        />
      </div>

      {/* Tablet and Mobile */}
      <div className='d-block d-lg-none'>
        <Nameplate
          size='small'
          image={
            <h1 className='mc-w-100 d-flex align-items-start justify-content-start mc-my-4'>
              <NextImage
                alt={course.instructorName || ''}
                className={classes.nameplateImage}
                src={course.leftAlignedNameplate || ''}
                objectFit='contain'
                sizes='150px'
                layout='fill'
                priority
              />
            </h1>
          }
          subText={course.headline}
          className={classes.nameplate}
        />
      </div>
    </>
  )
}
